import { createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../utils/request';
import { METHOD_PATCH } from '../../constants/api';
import getMyProfile from './getMyProfile';

const pathMyProfile = createAsyncThunk('profile/pathMyProfile',
  async (formData = {}, { rejectWithValue, dispatch }) => {
    try {
      const { data: user } = await authSet(METHOD_PATCH, '/me', formData);
      dispatch(getMyProfile());
      return user;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default pathMyProfile;
